import React, { useEffect, useState } from "react";
import { finalizeCheckoutSession } from "../services/api";

function BillingSuccessPage() {
  const [message, setMessage] = useState("Finalizing your Pro upgrade...");

  useEffect(() => {
    async function run() {
      try {
        const params = new URLSearchParams(window.location.search);
        const sessionId = params.get("session_id");

        if (!sessionId) {
          setMessage("Missing checkout session.");
          return;
        }

        const data = await finalizeCheckoutSession(sessionId);

        if (data.plan === "pro") {
          setMessage("Success. Your account is now on Pro.");
          setTimeout(() => {
            window.location.href = "/dashboard";
          }, 1500);
        } else {
          setMessage("Checkout completed, but Pro has not been activated yet.");
        }
      } catch (err) {
        setMessage(err.message || "Failed to verify checkout.");
      }
    }

    run();
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#050b17", color: "white", padding: "24px" }}>
      <div style={{ maxWidth: "540px", background: "#0d1627", borderRadius: "20px", padding: "28px", border: "1px solid rgba(255,255,255,0.08)" }}>
        <h1>Tradernal Billing</h1>
        <p style={{ color: "#9fb0cf" }}>{message}</p>
      </div>
    </div>
  );
}

export default BillingSuccessPage;